"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.button.login': 'Accedi Ora',
    'activate.button.back_login': 'Torna al Login',
    'activate.button.register_again': 'Registrati Nuovamente',
};
